﻿$("#boatInfo").on('shown.bs.collapse', function (e) {
    var offset = $('.card', this).offset();
    if (offset) {
        $('html,body').animate({
            scrollTop: $('.card-header', this).offset().top - 70
        }, 250);
    }
});

$('#boatInfo').on('show.bs.collapse', function () {
    $('.collapse', this).removeClass("show");
});

(function boatPicker() {
    //BOAT PICKER SECONDARY CONTROLLER
    if ($(".secondary-template-item").length == 0) return;
    var arrowRight = $("#arrow-next-icon");
    var arrowLeft = $("#arrow-prev-icon");

    $(document).ready(function () {
        var itemWidth = $(".secondary-template-item").first().width()
        checkArrow();
        toggleMobileBoatPicker();
        //toggleBoats();
       

        //Animating the slide forth and back buttons to slide the width of one item (25%)

        $("#arrow-prev-icon").click(function () {
            $('.area-inner').animate({
                scrollLeft: "-=" + itemWidth
            }, "slow");

        });

        $("#arrow-next-icon").click(function () {
            console.log(itemWidth);
            $('.area-inner').animate({
                scrollLeft: "+=" + itemWidth
            }, "slow");
        });

    });

    $(window).resize(function () {
        checkArrow();
    });

    function toggleMobileBoatPicker() {
        $(".boat-model-card.secondary-template-item").click(function () {
            siblings = $(this).siblings(".boat-model-card.secondary-template-item");
            siblings.removeClass("active");

            $(this).toggleClass("active");
        });
    };

    //Activating the slide forth and back buttons in the event that there is more than 4 or 6 items available
    function checkArrow() {
        if ($(window).width() > 1200) {
            if (document.querySelectorAll('.secondary-template-item').length > 6) {
                arrowRight.show();
                arrowLeft.hide();
            }
            else {
                arrowRight.hide();
            }
        } else if ($(window).width() <= 1200) {
            if (document.querySelectorAll('.secondary-template-item').length > 4) {
                arrowRight.show();
                arrowLeft.hide();
            }
            else {
                arrowRight.hide();
            }
        }
    }

    //Check if scrolled all the way right, to remove right arrow

    $('.area-inner').scroll(function (e) {
        var _this = this
        $(arrowRight, this).css({
            display: _this.scrollWidth < _this.scrollLeft + _this.clientWidth + 20 ? 'none' : 'block'
        });

        if ($(".area-inner").scrollLeft() > 0) {
            arrowLeft.show();
        } else {
            arrowLeft.hide();
        }
    });
})();
